// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { Step } from '@med/app/home/demo/guided-tour/models/step';

export const stepIdUpdated = createAction('[GUIDED TOUR] Step id updated', props<{ stepId: string }>());
export const stepsUpdated = createAction('[GUIDED TOUR] Step list updated', props<{ steps: Step[] }>());
export const stepUpdated = createAction('[GUIDED TOUR] Step updated', props<{ step: Step }>());
